import intlTelInput from "intl-tel-input";
import IMask from "imask";
import JustValidate from "just-validate";
import { getFetch } from "./utilidades/getFetch";
import { loadBotao } from "./utilidades/loadBotao";
import { obterDispositivo } from "./utilidades/obterDispositivo";
import i18next from "i18next";
import { inicializarInternacionalizacao } from "./localizacao/contato/Contato";
import { postFetch } from "./utilidades/postFetch";
import TomSelect from 'tom-select';
import { isNullOrEmpty } from './utilidades/isNullOrEmpty';
import { getGeoData } from './utilidades/geoData';
import { toastErroCarregar } from "./utilidades/toastErroCarregar";

const contato = {
    selectAssuntosCategorias() {
        const templateRender = {
            option: function (data, escape) {
                return `
                    <div class="">
                        <p class="mb-0">${escape(data.Titulo)}</p>
                        <p class="mb-0 text-muted"><small>${escape(data.Descricao)}</small></p>
                    </div>
                `;
            },
            item: function (data, escape) {
                return '<div title="' + escape(data.Descricao) + '">' + escape(data.Titulo) + '</div>';
            }
        };

        let opcoesSubcategorias = [];
        const avisoAssuntoSelecionado = document.getElementById('row-aviso-assunto-selecionado');
        const assuntoSubcategoriaID = document.getElementById('AssuntoSubcategoriaID');
        const todoFormulario = document.getElementById('todos-campos-formulario');

        function _mostrarBoxSelecionadoTextoPadrao(subcategoriaSelecionada, callbackTextoNulo = null) {
            if (isNullOrEmpty(subcategoriaSelecionada.SelecionadoTextoPadrao)) {
                if (callbackTextoNulo != null) {
                    callbackTextoNulo();
                }
                todoFormulario.classList.remove('d-none');
                avisoAssuntoSelecionado.classList.add('d-none');
                return;
            }

            if (!subcategoriaSelecionada.AberturaChamado)
                avisoAssuntoSelecionado.querySelector('button').classList.add('d-none');
            else
                avisoAssuntoSelecionado.querySelector('button').classList.remove('d-none');

            avisoAssuntoSelecionado.classList.remove('d-none');
            avisoAssuntoSelecionado.querySelector('.aviso-assunto-selecionado-container').innerHTML = subcategoriaSelecionada.SelecionadoTextoPadrao;

            function _clickBtnContinuarMesmoAssim(event) {
                avisoAssuntoSelecionado.classList.add('d-none');
                todoFormulario.classList.remove('d-none');
            }

            if (avisoAssuntoSelecionado.querySelector('button') != undefined) {
                avisoAssuntoSelecionado.querySelector('button').removeEventListener('click', _clickBtnContinuarMesmoAssim);
                avisoAssuntoSelecionado.querySelector('button').addEventListener('click', _clickBtnContinuarMesmoAssim);
            }
        }

        const selectAssuntoSubcategoria = new TomSelect('#AssuntoSubcategorias', {
            plugins: ['clear_button'],
            valueField: 'ID',
            labelField: 'Titulo',
            searchField: 'Titulo',
            preload: true,
            onChange: (value) => {

                avisoAssuntoSelecionado.classList.add('d-none');
                todoFormulario.classList.add('d-none');

                const subcategoriaSelecionada = opcoesSubcategorias.find(x => x.ID == value);

                if (subcategoriaSelecionada != undefined) {
                    assuntoSubcategoriaID.value = subcategoriaSelecionada.ID;
                    _mostrarBoxSelecionadoTextoPadrao(subcategoriaSelecionada);
                }
            }
        });

        new TomSelect('#Assuntos', {
            plugins: ['clear_button'],
            valueField: 'ID',
            labelField: 'Titulo',
            searchField: 'Titulo',
            preload: true,
            load: (query, callback) => {
                var url = `/${CULTURE_EMPREGARE}/PaginasEstaticas/ObterAssuntoCategorias`;
                fetch(url)
                    .then(response => response.json())
                    .then(json => {
                        callback(json.dados);
                    }).catch(() => {
                        callback();
                    });
            },
            onChange: (value) => {

                if (isNullOrEmpty(value)) {
                    avisoAssuntoSelecionado.classList.add('d-none');
                    todoFormulario.classList.add('d-none');
                    document.getElementById('row-assunto-subcategoria').classList.add('d-none');
                    return;
                }

                getFetch(`/${CULTURE_EMPREGARE}/PaginasEstaticas/ObterAssuntoSubcategorias?assuntoCategoriaID=` + value,
                    (resultado) => {

                        opcoesSubcategorias = resultado.dados;

                        if (opcoesSubcategorias.length > 0) {

                            selectAssuntoSubcategoria.clear(); //atual seleção
                            selectAssuntoSubcategoria.clearOptions();
                            selectAssuntoSubcategoria.addOptions(opcoesSubcategorias);

                            if (opcoesSubcategorias.length == 1) {
                                document.getElementById('row-assunto-subcategoria').classList.add('d-none');
                                selectAssuntoSubcategoria.setValue(opcoesSubcategorias[0].ID);
                            } else {
                                document.getElementById('row-assunto-subcategoria').classList.remove('d-none');
                                todoFormulario.classList.add('d-none');
                                avisoAssuntoSelecionado.classList.add('d-none');
                            }
                        }

                    },
                    (erro) => {
                        console.log(erro);
                    }
                );

            },
            render: templateRender
        });
    },
    FormConfig(form) {
        ////INTL-TEL

        const geoData = getGeoData();
        let paisID = 'BR';
        if (geoData.existe && geoData.data.pais) {
            paisID = geoData.data.pais;
            console.log(paisID)
        }

        const input = form.querySelector("#telefone");
        let inputItlt = intlTelInput(input, {
            initialCountry: paisID.toLowerCase(),
            preferredCountries: ['br', 'cl', 'ar', 'es', 'pt', 'us', 'fr'],
            dropdownContainer: document.querySelector("#form-body"),
            customContainer: "d-block",
            autoPlaceholder: "aggressive",
            utilsScript: "/assetsV2/lib/intl-tel-util/utils.js",
        });

        /// Text-Editor
        //const mensagemContainer = form.querySelector("#mensagem");
        //const editor = suneditor.create(mensagemContainer, {
        //    width: "auto",
        //    maxWidth: "700px",
        //    height: "auto",
        //    minHeight: "200px",
        //    maxHeight: "350px",
        //    font: "Arial",
        //    resizingBar: false,
        //    plugins: [horizontalRule, list],
        //    buttonList: [["bold", "italic", "strike"], ["list"], ["horizontalRule"]],
        //    lang: pt_br,
        //});

        // CPF config
        const cpf = form.querySelector('[inputmask="cpf"]');
        const cpfRow = form.querySelector("#row-cpf");
        let pais = form.querySelector("#paisID");

        // Usar o numero 0 na mask para definir conteudo como numerico
        var maskOptions = {
            mask: "000.000.000-00",
        };
        var mask = IMask(cpf, maskOptions);
        console.log(pais.value);
        if (pais.value == null || pais.value == "")
            pais.value = "BR";

        pais.addEventListener("change", function () {
            let id = pais.value;

            if (id == "BR") {
                cpfRow.removeAttribute("hidden");
                validar.addField("#cpf", [
                    { rule: "required", errorMessage: i18next.t('FormularioContatoValidacaoCpfObrigatorio') },
                    {
                        rule: "minLength",
                        value: 14,
                        errorMessage: i18next.t('FormularioContatoValidacaoCpf'),
                    },
                    {
                        rule: "maxLength",
                        value: 14,
                    },
                ])

            }
            else {
                cpfRow.setAttribute("hidden", "");
                validar.removeField('#cpf');
            }
        });

        /// Anexo de Arquivo
        let htmlAnexo = [];
        let indexAnexos = 0;
        let anexarBtn = form.querySelector("#anexarArquivo");

        anexarBtn.addEventListener("click", function () {
            htmlAnexo.push(
                `<div id='anexo-${indexAnexos}'><input id='input-file-${indexAnexos}' class='input-file-container' type='file' name='anexos' value='' />`
            );
            htmlAnexo.push(`<span id='file-name-${indexAnexos}'></span>`);
            htmlAnexo.push(
                `<a class='ml5 removerAnexo' data-anexoId='anexo-${indexAnexos}'></a></div>`
            );
            form
                .querySelector("#anexos")
                .insertAdjacentHTML("afterbegin", htmlAnexo.join(""));
            htmlAnexo = [];

            const input = form.querySelector(`#input-file-${indexAnexos}`);
            let removeBtn = form.querySelector(`.removerAnexo`);
            let fileName = form.querySelector(`#file-name-${indexAnexos}`);

            input.click();
            input.addEventListener("change", function (e) {
                fileName.textContent = e.target.files[0].name;
                removeBtn.textContent = " x";
            });
            indexAnexos += 1;
            removeBtn.addEventListener("click", function (e) {
                const anexo = this.getAttribute("data-anexoId");
                form.querySelector(`#${anexo}`).remove();
            });
        });

        /// Validacao dos campos
        const validar = new JustValidate(form, {
            errorFieldCssClass: "is-invalid",
        });

        validar
            .addField("#Assuntos", [
                { rule: "required", errorMessage: i18next.t('FormularioContatoValidacaoAssunto') },
            ])
            .addField("#nome", [{ rule: "required", errorMessage: i18next.t('FormularioContatoValidacaoNome') }])
            .addField("#email", [
                { rule: "required", errorMessage: i18next.t('FormularioContatoValidacaoEmailObrigatorio') },
                {
                    rule: "email",
                    errorMessage: i18next.t('FormularioContatoValidacaoEmail'),
                },
            ])
            .addField(
                "#telefone",
                [{ rule: "required", errorMessage: i18next.t('FormularioContatoValidacaoTelefone') }],
                {
                    errorsContainer: "#telefone-container",
                }
            )
            .addField("#paisID", [
                { rule: "required", errorMessage: i18next.t('FormularioContatoValidacaoPais') },
            ])
            .addField("#cpf", [
                { rule: "required", errorMessage: i18next.t('FormularioContatoValidacaoCpfObrigatorio') },
                {
                    rule: "minLength",
                    value: 14,
                    errorMessage: i18next.t('FormularioContatoValidacaoCpf'),
                },
                {
                    rule: "maxLength",
                    value: 14,
                },
            ])
            .addField("#mensagem", [
                {
                    rule: "required",
                    errorMessage: i18next.t('FormularioContatoValidacaoDetalhesProblema'),
                },
            ]);


        //Submit
        form.addEventListener("submit", (e) => {
            // Adicoes ao iput do form
            //form.querySelector("#mensagemHtml").value = editor.getContents();
            //mensagemContainer.value = editor.getText();
            form.querySelector("#plataforma").value = obterDispositivo();
            form.querySelector("#telefonePaisCode").value = inputItlt.getSelectedCountryData().dialCode;

            // Checa se algum input de arquivo veio vazio e se veio delata o input field
            let anexos = form.querySelectorAll(".input-file-container");
            for (let i = 0; i < anexos.length; i++) {
                if (anexos[i].value == "" || anexos[i].value == null)
                    anexos[i].remove();
            }

            //Revalida o form dps das adicoes se ele for valido salva
            validar.revalidate().then((isValid) => {
                if (isValid) {
                    contato.salvar(form);
                }
            });
        });

        return validar;
    },
    async getInformacaoLogado(form, validar) {
        const callbackSucesso = (data) => {
            if (data.logado == true) {
                const telefoneInput = form.querySelector("#telefone");

                const telefoneCelularPaisCode =
                    data.pessoa.CelularPaisCode != null
                        ? data.pessoa.CelularPaisCode
                        : data.pessoa.TelefonePaisCode;

                const telefoneCelular =
                    data.pessoa.Celular != null
                        ? data.pessoa.Celular
                        : data.pessoa.Telefone;

                form.querySelector("#pessoaID").value = data.pessoa.PessoaID;
                form.querySelector("#nome").value = data.pessoa.Nome;
                form.querySelector("#email").value = data.pessoa.Email;
                form.querySelector("#paisID").value = data.pessoa.PaisID;
                if (data.pessoa.PaisID == 'BR') {
                    form.querySelector("#cpf").value = data.pessoa.Cpf;
                } else {
                    validar.removeField('#cpf');
                }

                document.getElementById('nome-candidato').textContent = data.pessoa.Nome;

                intlTelInput(telefoneInput, {
                    preferredCountries: ['br', 'cl', 'ar', 'es', 'pt', 'us', 'fr'],
                    dropdownContainer: document.querySelector("#form-body"),
                    customContainer: "d-block",
                }).setNumber(telefoneCelularPaisCode || '');
                telefoneInput.value = telefoneCelular;
            }
        };
        getFetch(
            `/${CULTURE_EMPREGARE}/PaginasEstaticas/GetDetalhesPessoa`,
            callbackSucesso,
            null,
            null
        );
    },
    async salvar(form) {
        const btnEnviar = form.querySelector("#submit-btn");

        const fileInputs = form.querySelectorAll('input[type="file"]');
        const maxTotalSize = 10 * 1024 * 1024; // Limite total, por exemplo, 10MB
        let totalSize = 0;

        fileInputs.forEach(fileInput => totalSize += fileInput.files[0].size);
        if (totalSize > maxTotalSize) {
            toastErroCarregar(i18next.t('FormularioContatoValidacaoArquivosGrandes'));
            return;
        }

        loadBotao.mostrar(btnEnviar);
        const formData = new FormData(form);

        const callbackSucesso = () => {
            loadBotao.esconder(btnEnviar);
            form.setAttribute("hidden", "");
            document.querySelector("#ticket-enviado").removeAttribute("hidden");
        }

        const callbackErro = () => loadBotao.esconder(btnEnviar);
        postFetch(`/${CULTURE_EMPREGARE}/PaginasEstaticas/CriarTicketContato/`, formData, callbackSucesso, callbackErro, callbackErro)
    },
    Init() {
        inicializarInternacionalizacao()
        const form = document.getElementById("form-criar-ticket");

        contato.selectAssuntosCategorias();

        const validar = contato.FormConfig(form);
        contato.getInformacaoLogado(form, validar);
    },
};

contato.Init();
